export default [12, 14, 16, 18, 20, 24, 32, 50, 60, 79]